import { MouseEvent } from "react";
import { NavigateFunction } from "react-router-dom";
import { SidebarClickHandler } from "./SidebarClickHandler";

export function SidebarAllowedNavigate(
    linkToNavigate: string, 
    needOrgAndWorspaceSetted: boolean, 
    e: MouseEvent<HTMLElement, globalThis.MouseEvent>,
    organization: string,
    workspace: string,
    navigateSystem: NavigateFunction
) {    
    if (needOrgAndWorspaceSetted) {
      if (organization != "" && workspace != "") {
        SidebarClickHandler(e.ctrlKey, linkToNavigate, navigateSystem);
      } else {
        throw new Error("sidebar not allowed to navigate.");
      }
    } else {
      if (organization != "") {
        SidebarClickHandler(e.ctrlKey, linkToNavigate, navigateSystem);
      } else {
        throw new Error("sidebar not allowed to navigate.");
      }
    }
  }
